import type { HelpFile } from '../../types/help'
import { SystemsTestIds } from '../../../testids/SystemsTestIds'

export const systemsHelp: HelpFile = {
  docPage: '/docs/systems/overview',
  texts: {
    [SystemsTestIds.systemsList]:
      'Alle an die IAM-Plattform angebundenen Zielsysteme. Jeder Eintrag ist eine nachgelagerte Anwendung oder ein Verzeichnis, in das Zugriff bereitgestellt wird.',
    [SystemsTestIds.btnNewSystem]:
      'Neues Zielsystem vom festgelegten Typ anlegen. Pflichtattribute leiten sich aus den Attributdefinitionen des Typs ab.',
  },
}
